<app-basic-modal [status]="modalOkSingUp" title="" [modalName]="'singup_manual_ok'" [showClose]="false" [title]="'¡Registro Exitoso!'">
  <div class="container cupon singup-ok-modal">
    <div class="row">
      <div class="col-12">
        <img id="singup-ok-img" class="singup-ok-img" src="../../../assets/fanaticas-landing/check.svg" alt="logo-check">
      </div>
      <div class="col-12">
        <button class="singup-ok-btn-close" (click)="reloadPage()"> Cerrar </button>
      </div>
    </div>
  </div>
</app-basic-modal>
